import { Component, CUSTOM_ELEMENTS_SCHEMA, HostListener, OnInit, signal, ViewChild } from '@angular/core';
import { AgGridModule } from 'ag-grid-angular';
import { ColDef, GridApi, GridReadyEvent, GridOptions, ModelUpdatedEvent } from 'ag-grid-community';
import { SplitterModule } from 'primeng/splitter';
import { SearchService } from '../../shared/services/search.service';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { CoilDetailComponent } from '../../components/coil-detail/coil-detail.component';
import { OrderDetailComponent } from '../../components/order-detail/order-detail.component';
import { FormsModule } from '@angular/forms';
import { SearchBarComponent } from '../../components/search-bar/search-bar.component';
import { PaginationBarComponent } from '../../components/pagination-bar/pagination-bar.component';
import { SearchResult } from '../../shared/entities/searchResult';
import { CoilSheet } from '../../shared/entities/coilSheet';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { DisclaimerComponent } from '../../components/disclaimer/disclaimer.component';
import { Order } from '../../shared/entities/order';
import { CoilAnalyticsComponent } from '../../components/coil-analytics/coil-analytics.component';
import { SearchCriteria } from '../../shared/helpers/search-criteria/search-criteria';
import { CommonModule, DatePipe } from '@angular/common';
import { Utility } from '../../shared/entities/utils';
import { MeasurementsDataService } from '../../shared/services/measurements-data.service';
import { CompanyDropdownComponent } from '../../shared/company-dropdown/company-dropdown.component';

@Component({
  selector: 'app-order-overview',
  standalone: true,
  imports: [
    AgGridModule,
    SplitterModule,
    DialogModule,
    ButtonModule,
    CoilDetailComponent,
    OrderDetailComponent,
    FormsModule,
    SearchBarComponent,
    PaginationBarComponent,
    NgxSpinnerModule,
    DisclaimerComponent,
    CoilAnalyticsComponent,
    CommonModule,CompanyDropdownComponent
  ],
  providers: [DatePipe],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './order-overview.component.html',
  styleUrl: './order-overview.component.scss'
})
export class OrderOverviewComponent implements OnInit {

  @ViewChild(OrderDetailComponent) orderDetailComponent!: OrderDetailComponent;

  searchCriteria: SearchCriteria = new SearchCriteria();

  searchText: string = '';
  shouldShowDisclaimer: boolean = true;
  showOrderDetail: boolean = true;
  hideBackButton: boolean = false;


  coilDataChanged = signal<boolean>(false);

  rowDataOrder: any = [];
  rowDataCoil: any = [];

  gridOptions: GridOptions = {
    suppressCellFocus: true
  };

  // Column Definitions Orders: Defines & controls grid columns.
  colDefsOrder: ColDef[] = [
    { field: "salesOrderNumber", headerName: "Order #", flex: 1 },
    { field: "customerOrderNumber", headerName: "Customer Order #", flex: 1 },
    { field: "productType", headerName: "Product Type", flex: 1 },
    { field: "numberOfCoilsOrdered", headerName: "Number of Coils", flex: 1 },
    { field: "orderDate", headerName: "Date of order", flex: 1, resizable: false, valueGetter: (params) => { return this.datePipe.transform(params.data.orderDate, 'dd-MM-yyyy')} }
  ];

  public rowSelection: 'single' | 'multiple' = 'single';

  private gridApiOrder!: GridApi;

  selectedOrder: Order = {};
  selectedCoil: CoilSheet = {};

  searchResults!: SearchResult;
  regionMeasurementUnits: any = {};
  selectedCmpList:any;
  constructor(private searchService: SearchService,
    private toastr: ToastrService,
    private router: Router,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private datePipe: DatePipe,
    private measurementsDataService: MeasurementsDataService) {
      this.regionMeasurementUnits = this.measurementsDataService.regionMeasurementUnits();
    }

   //logic for back brower button handling
    @HostListener('window:popstate', ['$event'])
    onPopState(event:any) {
      this.doOrderPageSearch( this.searchCriteria.page -1)
    }
  ngOnInit(): void {
    this.route.queryParams.subscribe((params) =>{
      this.searchText = params['searchText'];
      this.shouldShowDisclaimer = params['shouldShowDisclaimer'] === 'true';
    });
    this.searchCriteria = this.searchService.orderSearchCriteria;
    this.searchCriteria.searchText = this.searchText;
    this.searchCriteria.page = 0;
    this.doSearchOrderAPICall();
    this.hideBackButton = true;
  }
  comapnySelectionChange(data: any){
    this.selectedCmpList=data;
   this.doSearchOrderAPICall();
    }
  doSearchOrderAPICall() {
    this.spinner.show();
    this.searchService.searchOrders(this.searchCriteria,this.selectedCmpList).subscribe({
      next: this.showNextResults,
      error: this.showErrorInResults});
  }

  showNextResults = (result: SearchResult) => {
    if (result && result.content.length > 0) {
      const currentPageNumber = result.pageable.pageNumber + 1;
      const queryParams = { searchText: this.searchText, shouldShowDisclaimer: this.shouldShowDisclaimer, page: currentPageNumber };
      this.router.navigate([], { queryParams });
      this.searchService.setSearchResults(result);
      this.searchResults = result;
      this.selectedOrder =result.content[0];
      this.rowDataOrder = [...result.content];
      this.spinner.hide();

      if (result.sort && result.sort.length > 0) {
        const sortInfo = result.sort[0]; // Assuming only one sort rule for simplicity
        const sortColumnDef = this.colDefsOrder.find(columnDef => columnDef.field === sortInfo.property);

        // Update sorting order for the sort column
        if (sortColumnDef) {
          sortColumnDef['sort'] = sortInfo.direction.toLowerCase(); // Convert direction to lowercase (e.g., "asc" or "desc")
        }
      }
    } else {
      this.rowDataOrder=[]
      this.spinner.hide();
      this.toastr.warning(
        'No search result, please change your search criteria'
      );
    }
  }

  showErrorInResults = (error: any) => {
    this.spinner.hide();
    this.toastr.error(`Error: ${error.error.detail}`);
  }

  getOrderCoilSheets(_idOrder: string) {
    this.rowDataCoil = [];
    this.searchService
      .getCoilSheetOrders(_idOrder)
      .subscribe((result: CoilSheet[]) => {
        if (result) {
          this.rowDataCoil = this.checkMeasurement(result);
          this.selectedCoil = this.rowDataCoil[0];
        } else {
          this.selectedCoil= <CoilSheet>{}
          this.toastr.warning(
            'No search result, please change your search criteria'
          );
        }
      });
  }

  checkMeasurement(coils: CoilSheet[]) {
    let regionUnit = '';
    let coilsWithUnits: CoilSheet[] = [];
    this.measurementsDataService.getMeasurementsData.subscribe(unit => regionUnit = unit);
    coils.forEach((item: CoilSheet) => {
        item.isSelected = false;
        if(regionUnit === 'US_CUSTOMARY_UNITS') {
          if(item.width) item.width = Utility.convertMillimeterToInch(item.width).toFixed(3);
          if(item.thickness) item.thickness = Utility.convertMillimeterToInch(item.thickness).toFixed(3);
          if(item.outsideDiameter) item.outsideDiameter = Utility.convertMillimeterToInch(item.outsideDiameter);
          if(item.length) item.length = Utility.convertMeterToFeet(item.length);
          if(item.weight) item.weight = Utility.convertEUTonToUSTon(item.weight);
          if(item.tensileStrength) item.tensileStrength = Utility.convertMpaToPsi(item.tensileStrength);
          if(item.yieldStrength) item.yieldStrength = Utility.convertMpaToPsi(item.yieldStrength);
          if(item.thicknessLowerTolerance) item.thicknessLowerTolerance = Utility.convertMillimeterToInch(item.thicknessLowerTolerance);
          if(item.thicknessUpperTolerance) item.thicknessUpperTolerance = Utility.convertMillimeterToInch(item.thicknessUpperTolerance);
          if(item.widthLowerTolerance) item.widthLowerTolerance = Utility.convertMillimeterToInch(item.widthLowerTolerance);
          if(item.widthUpperTolerance) item.widthUpperTolerance = Utility.convertMillimeterToInch(item.widthUpperTolerance);
        }else{
          if(item.width) item.width = Number((item.width).toFixed(2));
          if(item.thickness) item.thickness = Number((item.thickness).toFixed(3));
          if(item.thickness) item.thickness =  +Number(Math.round((item.thickness) * 1000) / 1000).toFixed(3);
        }
        coilsWithUnits.push(item);
      });
      return coilsWithUnits;
  }

  onSearch(data: any) {
    if (data.selected === '2') {
      this.gridApiOrder.resetColumnState();
      this.searchText = data.text;
      this.searchCriteria.searchText = this.searchText;
      this.searchCriteria.page = 0;
      const navigationExtras: NavigationExtras = {queryParams: {searchText: this.searchText, shouldShowDisclaimer: this.shouldShowDisclaimer}};
      this.router.navigate(['orders'], navigationExtras);
      this.doSearchOrderAPICall();
    } else {
      this.searchCoilData(data.text,this.selectedCmpList);
    }
  }

  /**
   * Get api to access order grid
   *
   * @param params
   */
  onOrderGridReady(params: GridReadyEvent) {
    this.gridApiOrder = params.api;
  }

  onOrderSelectionChanged() {
    const selectedRows = this.gridApiOrder.getSelectedRows();
    this.selectedOrder = selectedRows[0];
    if(this.selectedOrder?._id) {
      this.getOrderCoilSheets(this.selectedOrder._id);
    }
  }

  onCoilSelectionChanged(coil: any) {
    this.selectedCoil = coil;
  }

  /**
   * The function is called on clicking of coil Nr link
   *
   * @param event
   */
  onCoilCellClicked(coil: any) {
    this.selectedCoil = coil;
  }

  searchOrderData(searchText: string) {
    this.spinner.show();
    let orderSearchCriteria = new SearchCriteria(searchText);
    this.searchService.searchOrders(orderSearchCriteria,this.selectedCmpList).subscribe({ next: (result: SearchResult) => {

      if (result && result.content.length > 0) {
        this.searchService.setSearchResults(result);
        this.searchResults = result;
        this.searchText = searchText;
        this.spinner.hide();
        const navigationExtras: NavigationExtras = {queryParams: {searchText: searchText, shouldShowDisclaimer: this.shouldShowDisclaimer}};
        this.router.navigate(['orders'], navigationExtras);
      } else {
        this.searchService.setSearchResults(result);
      this.searchResults = result;
      this.selectedCoil= <CoilSheet>{}
        this.spinner.hide();
        this.toastr.warning(
          'No search result, please change your search criteria'
        );
      }
    }, error: (error: any) => {
      this.spinner.hide();
    }});
  }

  onCoilSelect() {
    this.searchCoilData(this.searchCriteria.searchText,this.selectedCmpList);
  }

  onOrderSelect() {
    this.searchOrderData(this.searchCriteria.searchText);
  }

  searchCoilData(searchText: string,selectedCmpList:any) {
    this.spinner.show();
    let coilSearchCriteria = new SearchCriteria(searchText);
    this.searchService.searchCoils(coilSearchCriteria,selectedCmpList).subscribe({next: (result: SearchResult) => {

      if (result && result.content.length > 0) {
        this.searchService.setSearchResults(result);
        this.spinner.hide();
        const navigationExtras: NavigationExtras = {queryParams: {searchText: searchText, shouldShowDisclaimer: this.shouldShowDisclaimer}};
        this.router.navigate(['coils'], navigationExtras);
      } else {
        this.searchService.setSearchResults(result);
      this.searchResults = result;
      this.selectedCoil= <CoilSheet>{}
        this.spinner.hide();
        this.toastr.warning(
          'No search result, please change your search criteria'
        );
      }
    }, error: (error: any) => {
      this.spinner.hide();
    }});
  }

  reinitializePage() {
    const currentUrl = this.router.url;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([currentUrl]);
    });
  }

  onSortChanged(event: any) {
    const sortModel = event.api.sortController.getSortModel();
    if(sortModel.length > 0){
      this.searchCriteria.setSorting(sortModel[0].colId, sortModel[0].sort);
      this.doSearchOrderAPICall();
    }
  }

  //Keeping the first row always selected
  onModelUpdated(event: ModelUpdatedEvent){
    event.api.forEachNode((node, index) => {
      if (index === 0) {
        node.setSelected(true);
      }
    });
  }

  onDisclaimerAccepted(visible: boolean) {
    this.shouldShowDisclaimer = visible;
  }

  doOrderPageSearch(pagetToSearch:number){
    //ensuring the firstpage -1  and last page+1 search is irrelavent  + Also ensuring the current number search once again for the Last & First
    if(pagetToSearch!=this.searchResults.number && pagetToSearch>=0 && pagetToSearch<this.searchResults.totalPages){
      this.searchCriteria.page=pagetToSearch;
      this.doSearchOrderAPICall();
    }else{
      if(pagetToSearch<0){
        this.router.navigate([''])
      }
      else{
        console.log('')
      }
    }

  }
}


